import { render } from "./OsBasedImageSelectionSearchView.vue?vue&type=template&id=2d211bc6&scoped=true"
import script from "./OsBasedImageSelectionSearchView.vue?vue&type=script&lang=js"
export * from "./OsBasedImageSelectionSearchView.vue?vue&type=script&lang=js"

import "./OsBasedImageSelectionSearchView.vue?vue&type=style&index=0&id=2d211bc6&lang=less&scoped=true"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d211bc6"]])

export default __exports__